"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.vehiclePropType = exports.transmissionTypePropType = exports.titleAndTextPropType = exports.pricePropType = exports.packagesPropType = exports.modelPropType = exports.imagePropType = exports.fuelTypePropType = exports.fabricPropType = exports.driveTypePropType = exports.dataPropType = exports.colorPropType = exports.additionalPriceGroupPropType = exports.accessoriesPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var pricePropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  displayValue: _propTypes["default"].string
});
exports.pricePropType = pricePropType;
var vehiclePropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  code: _propTypes["default"].string,
  price: pricePropType,
  name: _propTypes["default"].string,
  selected: _propTypes["default"]["boolean"]
});
exports.vehiclePropType = vehiclePropType;
var modelPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  code: _propTypes["default"].string,
  price: pricePropType,
  name: _propTypes["default"].string,
  selected: _propTypes["default"]["boolean"]
});
exports.modelPropType = modelPropType;
var titleAndTextPropType = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  text: _propTypes["default"].string
});
exports.titleAndTextPropType = titleAndTextPropType;
var colorPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  price: pricePropType,
  titleAndText: titleAndTextPropType,
  selected: _propTypes["default"]["boolean"]
});
exports.colorPropType = colorPropType;
var fabricPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  price: pricePropType,
  titleAndText: titleAndTextPropType,
  selected: _propTypes["default"]["boolean"]
});
exports.fabricPropType = fabricPropType;
var packagesPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  price: pricePropType,
  titleAndText: titleAndTextPropType,
  selected: _propTypes["default"]["boolean"]
});
exports.packagesPropType = packagesPropType;
var accessoriesPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  price: pricePropType,
  titleAndText: titleAndTextPropType,
  selected: _propTypes["default"]["boolean"]
});
exports.accessoriesPropType = accessoriesPropType;
var imagePropType = _propTypes["default"].shape({
  altText: _propTypes["default"].string,
  image: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var driveTypePropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  image: imagePropType,
  selected: _propTypes["default"]["boolean"]
});
exports.driveTypePropType = driveTypePropType;
var fuelTypePropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  selected: _propTypes["default"]["boolean"]
});
exports.fuelTypePropType = fuelTypePropType;
var transmissionTypePropType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  image: imagePropType,
  selected: _propTypes["default"]["boolean"]
});
exports.transmissionTypePropType = transmissionTypePropType;
var additionalPriceGroupPropType = _propTypes["default"].shape({
  color: _propTypes["default"].number,
  colorCode: _propTypes["default"].string,
  fabric: _propTypes["default"].number,
  fabricCode: _propTypes["default"].string,
  "package": _propTypes["default"].number,
  packageCodes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  accessory: _propTypes["default"].number,
  accessoryCodes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  destinationFees: _propTypes["default"].number
});
exports.additionalPriceGroupPropType = additionalPriceGroupPropType;
var dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  summaryText: _propTypes["default"].string,
  changeText: _propTypes["default"].string,
  includedText: _propTypes["default"].string,
  summaryTitle: _propTypes["default"].string,
  configurationTitle: _propTypes["default"].string,
  customisationTitle: _propTypes["default"].string,
  copyText: _propTypes["default"].string,
  vehicle: vehiclePropType,
  model: modelPropType,
  color: colorPropType,
  fabric: fabricPropType,
  packages: _propTypes["default"].arrayOf(packagesPropType),
  accessories: _propTypes["default"].arrayOf(accessoriesPropType),
  totalPrice: pricePropType,
  driveType: driveTypePropType,
  fuelType: fuelTypePropType,
  transmissionType: transmissionTypePropType,
  msrpDisclaimerId: _propTypes["default"].string,
  monthlyMsrpDisclaimerId: _propTypes["default"].string,
  buyMonthlyDisclaimerId: _propTypes["default"].string,
  interestRateDisclaimerId: _propTypes["default"].string,
  leaseMonthlyDisclaimerId: _propTypes["default"].string,
  annualMileageDisclaimerId: _propTypes["default"].string,
  dueAtLeaseSigningDisclaimerId: _propTypes["default"].string,
  addPriceDisclaimer: _propTypes["default"].bool,
  priceDisclaimerId: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});
exports.dataPropType = dataPropType;